const historicoStore = {
    state() {
        return {
            historico: '',
        };
    },
    mutations: {
        setHistorico(state, payload) {
            state.historico = payload;
        },
        setNovoHistorico(state, payload) {
            payload.pedidos.forEach((pedido) => {
                state.historico.push(pedido);
            });
        },

        changePedidos(state, payload) {
            state.historico.forEach((element) => {
                if (
                    element.sku === payload.sku &&
                    element.data_validade === payload.validade &&
                    element.loja === payload.loja &&
                    element.status === 'Aprovado'
                ) {
                    element.status = 'Precificado';
                }
            });
        },
    },
    actions: {
        setHistorico(context, payload) {
            context.commit('setHistorico', payload);
        },
        setNovoHistorico(context, payload) {
            context.commit('setNovoHistorico', payload);
        },
        changePedidos(context, payload) {
            context.commit('changePedidos', payload);
        },
    },
    getters: {
        getHistorico(state) {
            return state.historico;
        },
    },
};

export default historicoStore;
